import React from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  CalendarIcon,
  BookOpenIcon,
  UserIcon,
  CommandLineIcon
} from '@heroicons/react/24/outline'
import {
  HomeIcon as HomeIconSolid,
  CalendarIcon as CalendarIconSolid,
  BookOpenIcon as BookOpenIconSolid,
  UserIcon as UserIconSolid,
  CommandLineIcon as CommandLineIconSolid
} from '@heroicons/react/24/solid'

interface LayoutProps {
  children?: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()

  // 底部导航栏项目：首页、约课、教材、我的
  const navItems = [
    { id: 'home', name: '首页', href: '/dashboard', icon: HomeIcon, activeIcon: HomeIconSolid },
    { id: 'booking', name: '约课', href: '/booking', icon: CalendarIcon, activeIcon: CalendarIconSolid },
    { id: 'materials', name: '教材', href: '/materials', icon: BookOpenIcon, activeIcon: BookOpenIconSolid },
    { id: 'software-tools', name: '工具', href: '/software-tools', icon: CommandLineIcon, activeIcon: CommandLineIconSolid },
    { id: 'profile', name: '我的', href: '/profile', icon: UserIcon, activeIcon: UserIconSolid },
  ]

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      {/* 页面内容 */}
      <main className="flex-1">
        {children || <Outlet />}
      </main>

      {/* 底部导航栏 */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const active = isActive(item.href)
            const Icon = active ? item.activeIcon : item.icon
            return (
              <Link
                key={item.id}
                to={item.href}
                className={`flex flex-col items-center justify-center flex-1 h-full ${
                  active ? 'text-orange-500' : 'text-gray-500'
                }`}
              >
                <Icon className="w-6 h-6" />
                <span className="text-xs mt-1">{item.name}</span>
              </Link>
            )
          })}
        </div>
      </nav>
    </div>
  )
}
